__webpack_require__.p = "/quotes-generator/";